import { useState } from "react";
import { navLinks } from "@/mocks/cgua";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const goSearch = () => {
    if (query.trim().length === 0) return;
    setQuery("");
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/85 backdrop-blur-md border-b border-background-200">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <nav className="flex items-center justify-between gap-4 h-14 md:h-16">
          {/* brand */}
          <a
            href="#top"
            aria-label="17吃瓜 首页"
            className="flex items-center gap-2 shrink-0 cursor-pointer"
          >
            <span className="flex items-center justify-center w-7 h-7 md:w-8 md:h-8 rounded-full bg-primary-600 text-background-50">
              <i className="ri-flashlight-fill text-sm md:text-base" />
            </span>
            <span className="font-heading text-xl md:text-2xl font-extrabold tracking-tight text-foreground-950">
              17吃瓜
            </span>
          </a>

          {/* desktop nav */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((l) => (
              <a
                key={l.anchor}
                href={l.anchor}
                className="px-3 py-2 rounded-full text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-700 whitespace-nowrap transition-colors cursor-pointer"
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-2">
            <form
              className="flex items-center gap-2 rounded-full bg-background-100 border border-background-200 px-3 h-9 w-56"
              onSubmit={(e) => {
                e.preventDefault();
                goSearch();
              }}
            >
              <i className="ri-search-line text-sm text-foreground-500" />
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜瓜 / 搜合集"
                className="w-full bg-transparent outline-none text-sm placeholder:text-foreground-400 text-foreground-900"
                aria-label="搜索"
              />
            </form>
            <a
              href="#dingyue"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 text-background-50 text-sm font-semibold px-4 h-9 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-notification-3-line text-[15px]" />
              订阅追更
            </a>
          </div>

          {/* hamburger */}
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center w-9 h-9 rounded-full text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </nav>

        {/* mobile panel */}
        {open && (
          <div className="lg:hidden pb-4 border-t border-background-100 pt-3 space-y-1">
            {navLinks.map((l) => (
              <a
                key={l.anchor}
                href={l.anchor}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100 cursor-pointer"
              >
                {l.label}
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </a>
            ))}
            <a
              href="#dingyue"
              onClick={() => setOpen(false)}
              className="flex items-center justify-center gap-1.5 mt-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold px-4 py-2.5"
            >
              <i className="ri-notification-3-line text-[15px]" />
              订阅追更
            </a>
          </div>
        )}
      </div>
    </header>
  );
}